window.UpdateCookieBot = false;
var _NECESSARY   = 'necessary',
	_MARKETING   = 'marketing',
	_STATISTICS  = 'statistics',
	_PREFERENCES = 'preferences';
_allGdprCategories = [_NECESSARY , _MARKETING , _STATISTICS , _PREFERENCES] ;


bmLib.addTriggerListener( 'widgetsInstanceCreated', 'body', function (event , result , method ) {
	let isLoggedIn = getLoggedIn();
	if(!isLoggedIn){
		needToStartCookiePolicy();
	}
	else{
		bmLib.addTriggerListener( 'topBarLoaded', 'body', function (event , result , method ) {
			needToStartCookiePolicy();
		});
	}
});

bmLib.addTriggerListener( 'cookiePolicyAnswers', 'body', function (event , type) {
	cookiePolicyNotifyAnswers();
	updateThirdPartyResourcesDependentOnCookiePolicy();
} );

$(document).ready(function(){
	addSpecificCookieConsentListener();
	window.addedSpecificConsentListener = true ;
});

function addSpecificCookieConsentListener(){
	$('.gdpr-blocking a').on('click' , function () {
		let category = $(this).closest('.gdpr-blocking').attr('data-gdpr-category-consent') ;
		cookiePolicyAcceptSpecificCategory(category) ;
	});
}

function needToStartCookiePolicy(){
	if(typeof isUseCookiePolicyFeature === 'function' && isUseCookiePolicyFeature() && window.loadCookiePolicy !== 0){
		initCookiePolicy();
	}
}

function initCookiePolicy () {

	let customer = wdgGetSavedCustomer() ;
	// remove the banner for user that created before 03/11/2019
	if(!checkCookiePolicyExist() &&customer && Date.parse('2019-11-03') > Date.parse(customer.CreatedOn)){
		updateInternalCookieCategory(true , true , true , true);
	}
	if(checkCookiePolicyExist()){
		bmLib.fireTrigger('cookiePolicyAnswers', 'body');
	}
	else{
		$('.gdpr-blocking').each(function(){
			showGdprBlockingMessage($(this));
		}) ;
		addCookieBotListeners();
		appendCookieBotScriptToHead();
	}

}

function addCookieBotListeners(){
	if(window.addedCookieBotListeners !== true){
		window.addEventListener('CookiebotOnAccept', onCookieBotUpdate , false);
		window.addEventListener('CookiebotOnDecline', onCookieBotUpdate , false);
		window.addEventListener('CookiebotOnDialogDisplay', function (e) {
			$( 'body' ).addClass( 'cookie-policy-on-stage' );
			if (!checkCookiePolicyExist()){
				// create cookie policy if needed
				updateCookiePolicyCookie();
			}
		}, false);
	}

	window.addedCookieBotListeners  = true ;
}

function onCookieBotUpdate(){
	$( 'body' ).removeClass( 'cookie-policy-on-stage' );
	let comparisonCookieChoices = compareCookieChoices() ;
	if(comparisonCookieChoices === -1){
		// display popup
		if($('#change_account_details_tab #cookie-policy-delete-guidelines').length === 0){
			$('#change_account_details_tab').append('<div id="cookie-policy-delete-guidelines"></div>');
		}
		msg_popup_render({insertSelector : '#change_account_details_tab #cookie-policy-delete-guidelines' , formCoverSelector : '#change_account_details_tab'  , content : cookie_policy_translations.delete_cookie_instructions });
	}

	if(comparisonCookieChoices !== 0){

		updateInternalCookieCategory(Cookiebot.consent[_NECESSARY] ,Cookiebot.consent[_MARKETING] , Cookiebot.consent[_STATISTICS] , Cookiebot.consent[_PREFERENCES] );

		bmLib.fireTrigger('cookiePolicyAnswers', 'body');

		bmFireJelly( "cookie_policy_update" , { CookiePolicy : { marketing: getCookieCategory(_MARKETING) , statistics : getCookieCategory(_STATISTICS) , preferences: getCookieCategory(_PREFERENCES)  } } , 'jellyFormat');

	}
}

/**
 *
 * @returns {number} : 0 - no changes have been made , -1 - downgrade changes have been made , 1 - only upgrade changes have been made
 */
function compareCookieChoices(){

	let upgradeHappened = false ;
	let prevCategories = featureCookie.getData( 'cookie_policy', COOKIE_FEATURE_INTERNAL_TYPE );
	if (prevCategories == 1){
		prevCategories = {'necessary' : true, 'marketing':true, 'statistics':true, 'preferences' : true};
	}else {
		prevCategories = JSON.parse( prevCategories );
		if (!prevCategories) {
			// if no cookie exist initiate values with false
			prevCategories = {'necessary': false, 'marketing': false, 'statistics': false, 'preferences': false}
		}
	}

	for(let category in prevCategories){
		if(prevCategories[category] === true && Cookiebot.consent[category] === false){
			return -1 ;
		}
		if(prevCategories[category] === false && Cookiebot.consent[category] === true){
			upgradeHappened = true ;
		}
	}
	if(upgradeHappened){
		return 1 ;
	}
	else{
		return 0 ;
	}
}

function checkCookiePolicyExist () {
	return !!featureCookie.getData( 'cookie_policy', COOKIE_FEATURE_INTERNAL_TYPE );
}

function checkCookiePolicyCategory(category) {
	var cookiePolicy = getInternalCookiePolicyData();
	var isCookiePolicyDisabled = !isUseCookiePolicyFeature();
	if (isCookiePolicyDisabled) return true;
    return cookiePolicy && cookiePolicy[category] ? true : false;
}

function appendCookieBotScriptToHead(){
	let head= document.getElementsByTagName('head')[0];
	let script= document.createElement('script');
	script.type= 'text/javascript';
	script.id = "Cookiebot" ;
	script.src = "https://consent.cookiebot.com/uc.js" ;
	script.async = true ;
	script.setAttribute('data-cbid', "17ff036d-80ba-406f-9b49-a774371f0800");
	script.setAttribute('data-culture', wp_lang.substr(0,2).toUpperCase());
	head.appendChild(script);
}

function updateCookiePolicyCookie(){
	let allowCategory = featureCookie.getData( 'cookie_policy', COOKIE_FEATURE_INTERNAL_TYPE );
	allowCategory = JSON.parse(allowCategory) ;

	if (Cookiebot.consented || Cookiebot.declined){
		updateInternalCookieCategory(Cookiebot.consent[_NECESSARY], Cookiebot.consent[_MARKETING], Cookiebot.consent[_STATISTICS], Cookiebot.consent[_PREFERENCES]);
	}else if(allowCategory == 1){
		updateInternalCookieCategory(true, true, true, true);
	}
	else{
		return  false ;
	}
	return true ;


}


/**
 * update internal cookie policy data - the data is saved in json format
 * @param necessary
 * @param marketing
 * @param statistics
 * @param preferences
 */
function updateInternalCookieCategory(necessary, marketing, statistics, preferences){
	let data={'necessary' : necessary, 'marketing':marketing, 'statistics':statistics, 'preferences' : preferences};
	featureCookie.setData( 'cookie_policy', JSON.stringify(data), COOKIE_FEATURE_INTERNAL_TYPE  , COOKIE_FEATURE_EXPIRATION_LIFETIME );
}


/**
 * update third party (cookiebot) data
 * @param marketing
 * @param statistics
 * @param preferences
 */
function updateThirdPartyCookieCategory(preferences, statistics, marketing){
	if(!!window.Cookiebot && typeof window.Cookiebot.show == 'function'){
		submitCookiebotConsent();
	}
	else{
		window.addEventListener('CookiebotOnLoad', submitCookiebotConsent, false);
		window.addEventListener('CookiebotOnDialogInit', submitCookiebotConsent, false);
	}

	function submitCookiebotConsent(){
		Cookiebot.submitCustomConsent(preferences, statistics, marketing);

		window.removeEventListener('CookiebotOnLoad', submitCookiebotConsent, false);
		window.removeEventListener('CookiebotOnDialogInit', submitCookiebotConsent, false);
	}

}

function renderUpdateCookiePolicyForm(){

	// not to append the script twice if it was already appended
	if(!window.Cookiebot){
		appendCookieBotScriptToHead();
	}

	if(window.addedCookieBotListeners !== true){
		addCookieBotListeners();
	}
	//update the cookiebot data with internal cookie data
	let data = getInternalCookiePolicyData();
	if(data){
		updateThirdPartyCookieCategory(data[_PREFERENCES], data[_STATISTICS], data[_MARKETING]);

	}

}

function getInternalCookiePolicyData(){
	let dataConsent = featureCookie.getData('cookie_policy', COOKIE_FEATURE_INTERNAL_TYPE);
	if (dataConsent == 1)
		return {'preferences' : true, 'statistics': true, 'marketing': true};
	return JSON.parse(dataConsent);
}

function displayCookiebotIfNotOnStage(){
	if($( 'body' ).hasClass( 'cookie-policy-on-stage' ) === false ){
		Cookiebot.show();
	}
}


function updateParentWindowAboutCookiePolicyUpdate(){
	window.top.bmLib.fireTrigger('cookiePolicyAnswers', 'body' , ['notifyWindowCookiePolicy']);

}

function updateThirdPartyResourcesDependentOnCookiePolicy(){
	var i  , $element;
	for( i=0 ; i< _allGdprCategories.length ; i++){
		if(_allGdprCategories[i] == _NECESSARY){
			continue ;
		}
		if(getCookieCategory(_allGdprCategories[i])){
			$('[data-gdpr-category="' + _allGdprCategories[i] + '"]').each(function(){
				if($(this)[0].localName == 'script'){
					if(!$(this).attr('src')){
						$(this).attr('src' , $(this).attr('data-gdpr-src'));
						$element = $(this)[0].cloneNode() ;
						$("head").append($element);
						$(this).remove();
					}

				}
				else{
					$(this).attr('src' , $(this).attr('data-gdpr-src'));
					$(this).removeAttr('data-gdpr-src') ;
				}
			});
			$('.gdpr-blocking[data-gdpr-category-consent="' + _allGdprCategories[i] + '"]').hide();
			$('body').removeClass('gdpr-blocking-message');
		}
		else{
			showGdprBlockingMessage($('.gdpr-blocking[data-gdpr-category-consent="' + _allGdprCategories[i] + '"]'));
		}

	}
}

function showGdprBlockingMessage($elem){
	$elem.show();
	$('body').addClass('gdpr-blocking-message');
}


function cookiePolicyNotifyAnswers(){
	$( 'body' ).removeClass( 'cookie-policy-on-stage' );
	if(typeof jelly !== 'undefined' && typeof jelly.resetTargets == 'function'){
		jelly.resetTargets() ;
	}

	updateThirdPartyResourcesDependentOnCookiePolicy();
}

function cookiePolicyAcceptSpecificCategory(category){
	if(!getCookieCategory(category)){
		let preferences =  (category == _PREFERENCES) ? true : getCookieCategory(_PREFERENCES) ;
		let marketing = (category == _MARKETING) ? true : getCookieCategory(_MARKETING) ;
		let statistics = (category == _STATISTICS) ? true : getCookieCategory(_STATISTICS) ;
		if(window.Cookiebot && window.Cookiebot.submitCustomConsent){
			Cookiebot.submitCustomConsent(preferences,statistics,marketing);
		}
		else{
			updateInternalCookieCategory(true , marketing , statistics , preferences);
			bmLib.fireTrigger('cookiePolicyAnswers', 'body');
			bmFireJelly( "cookie_policy_update" , { CookiePolicy : { marketing: getCookieCategory(_MARKETING) , statistics : getCookieCategory(_STATISTICS) , preferences: getCookieCategory(_PREFERENCES)  } } , 'jellyFormat');
			// only if event is not triggered by other window
			if(window.self !== window.top){
				updateParentWindowAboutCookiePolicyUpdate();
			}
		}
	}
}




function addGdprBlockingMessage(containerSelector , gdprCategory , onConsentFunc){
	$(containerSelector).append(window.gdprBlockingMessage[gdprCategory]);
	if(window.addedSpecificConsentListener){
		addSpecificCookieConsentListener();
	}
	var gdprCategoryAlreadyConsented = false ;
	bmLib.addTriggerListener( 'cookiePolicyAnswers', 'body', function () {
		if(getCookieCategory(gdprCategory)){
			$('.gdpr-blocking[data-gdpr-category-consent="' + gdprCategory + '"]').hide();
			$('body').removeClass('gdpr-blocking-message');
			if(typeof onConsentFunc == "function" && !gdprCategoryAlreadyConsented){
				// the onConsentFunc for a third party should run only once when the category is consented, it can't be consented again in the same session, and we dont want it to run again if cosented another category in the same session
				onConsentFunc();
			}
		}
		else{
			showGdprBlockingMessage($('.gdpr-blocking[data-gdpr-category-consent="' + gdprCategory + '"]'));
		}
	} );

	if(!checkCookiePolicyExist()){
		showGdprBlockingMessage($('.gdpr-blocking[data-gdpr-category-consent="' + gdprCategory + '"]'));
	}
}


